"use strict";

exports.__esModule = true;
exports.MetricChartWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _MetricChartElement = require("./MetricChartElement");
var _ChartCard = require("../common/ChartCard");
var _Metrics = require("../../../Catalogs/Metrics");
var _MetricChartFields = require("./MetricChartFields");
var _MetricChartHeader = require("./MetricChartHeader");
var _MetricChartThumbnail = require("./MetricChartThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var metricLabel = function metricLabel(metricName) {
  try {
    var metric = (0, _Metrics.getMetricDefinition)(metricName);
    return metric ? metric.shortLabel || metric.name : metricName;
  } catch (e) {
    return metricName;
  }
};
var MetricChartWidget = exports.MetricChartWidget = {
  name: "MetricChart",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "MetricChartWidget.label",
    defaultMessage: "Metric Chart"
  }),
  icon: "label",
  group: _widgetGroups.METRIC_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "MetricChart",
      props: Object.assign({
        width: 256,
        height: 256,
        metricChartSeries: [{
          metricName: "utilization",
          seriesType: "line"
        }]
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "backgroundColor"],
  requiresProps: ["x", "y", "width", "height", "utilization"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 3840
    },
    height: {
      "default": 64,
      min: 32,
      max: 2160
    }
  },
  components: {
    Header: _MetricChartHeader.MetricChartHeader,
    Element: (0, _ChartCard.withChartCard)(_MetricChartElement.MetricChartElement, function (props) {
      var names = (props.metricChartSeries || []).map(function (series) {
        return metricLabel(series.metricName);
      }).filter(Boolean);
      return {
        title: names.length ? names.slice(0, 2).join(" · ") + (names.length > 2 ? " +" + (names.length - 2) : "") : /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "MetricChartWidget.card.title",
          defaultMessage: "Metrics"
        })
      };
    }),
    Fields: _MetricChartFields.MetricChartFields,
    Thumbnail: _MetricChartThumbnail.MetricChartThumbnail
  }
};